import script from "./Catalog.vue?vue&type=script&lang=ts&setup=true"
export * from "./Catalog.vue?vue&type=script&lang=ts&setup=true"

import "./Catalog.vue?vue&type=style&index=0&id=144ba1e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-144ba1e4"]])

export default __exports__